<template>
    <div>
        <SalesPaymentList />
    </div>
</template>

<script>
import SalesPaymentList from '@/components/sales/SalesPaymentList.vue'
export default {
  name: 'SalesPayment',
  components: {
    SalesPaymentList
  },
  mounted () {
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
